exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "header{display:block;margin:0;padding:0 30px;background:#232f3e}ul.navbar{display:flex;margin:0;padding:0;list-style:none}ul.navbar>li{padding:0 1em;margin:1em 0 1em}ul.navbar>li a,ul.navbar>li div{float:left;color:#fff;line-height:16px}ul.navbar>li a,ul.navbar>li a:hover{cursor:pointer;text-decoration:none}ul.navbar>li.title{font-weight:bold}ul.navbar>li.selected>a{font-weight:bold;color:#f90}ul.navbar>li.separated{border-left:1px solid #3d526c;padding-left:9px;margin-left:9px}ul.navbar>li.ml-auto{margin-left:auto}", ""]);

// exports
